import { ReactiveFormsModule } from "@angular/forms";
import { NgModule } from "@angular/core";
import { HeaderComponent } from "./header.component";
import { SlimLoadingBarModule } from "ng2-slim-loading-bar";
import { DropdownModule } from "ngx-dropdown";
import { ModalModule } from "ngx-modal";
import { CommonModule } from "@angular/common";
import { AddAccountComponent } from "../../main-settings/accounts/add-account/add-account.component";
import { DropdownModule as PrimeDropdownModule } from "primeng/dropdown";
import { NgSelectModule } from "@ng-select/ng-select";
import { PaginationComponent } from "../pagination/pagination.component";
import { NgbPaginationModule } from "@ng-bootstrap/ng-bootstrap";
import { CampaignViewerUserGuard } from "../../guards/campaign-viewer-user.guard";
import { Ng2TelInputModule } from 'ng2-tel-input';
import { ItiTelInputComponent } from '../../iti-tel-input/iti-tel-input.component';

@NgModule({
  declarations: [
    HeaderComponent,
    PaginationComponent,
    ItiTelInputComponent,
    AddAccountComponent
  ],
  imports: [
    CommonModule,
    SlimLoadingBarModule.forRoot(),
    DropdownModule,
    ModalModule,
    ReactiveFormsModule,
    PrimeDropdownModule,
    NgbPaginationModule,
    Ng2TelInputModule,
    NgSelectModule,
  ],
  providers: [CampaignViewerUserGuard],
  bootstrap: [HeaderComponent, PaginationComponent],
  exports: [
    CommonModule,
    HeaderComponent,
    SlimLoadingBarModule,
    PaginationComponent,
    AddAccountComponent,
    ReactiveFormsModule,
    Ng2TelInputModule,
    ItiTelInputComponent,
    AddAccountComponent
  ],
})
export class HeaderModule {}



// WEBPACK FOOTER //
// ./src/app/layout/header/header.module.ts